import React from 'react';
import { PanelSkeleton } from '@jira/servicedesk__proactive-support-sensor-details/src/PanelSkeleton.tsx';
import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { token } from '@atlaskit/tokens';

/**
 * Sync route.skeleton shown while the sensor-details entry-point chunk loads.
 * Mirrors page outer inset (space.300) + content inset (space.200) so padding
 * does not shift when the chunk mounts.
 */
const styles = cssMap({
	pageInset: {
		paddingTop: token('space.200'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.200'),
		paddingLeft: token('space.200'),
	},
});

export const SensorDetailsPageSkeleton = (): React.JSX.Element => (
	<Box xcss={styles.pageInset} aria-hidden="true">
		<PanelSkeleton />
	</Box>
);
